import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  constructor(private http: HttpClient) { }
private appConfig;
  loadAppConfig() {
    return lastValueFrom(this.http.get('/api/app/config'))
      .then(data => {
        this.appConfig = data;
      });
  }
  getConfig() {
    return this.appConfig;
  }
}
